/**
 * Whether a picture URL would make the browser contact Gravatar: an http(s) URL on `gravatar.com` or any subdomain.
 * Loading one sends the viewer's IP address and the member's email hash to Gravatar (#4602). Mirrors the API's
 * `GravatarPicture.IsGravatarUrl`.
 */
export function isGravatarUrl(url: string | null | undefined): boolean {
  const trimmed = url?.trim();
  if (!trimmed) {
    return false;
  }
  let parsed: URL;
  try {
    parsed = new URL(trimmed);
  } catch {
    return false;
  }
  if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') {
    return false;
  }
  const host = parsed.hostname.toLowerCase().replace(/\.$/, '');
  return host === 'gravatar.com' || host.endsWith('.gravatar.com');
}

/**
 * The picture URL the browser may load. With `gravatarServerImport` on, a Gravatar URL becomes null, so the avatar
 * shows initials until the server has imported a copy. With it off, the URL is returned as given.
 */
export function pictureUrlForBrowser(
  url: string | null | undefined,
  gravatarServerImport: boolean
): string | null {
  if (url == null) {
    return null;
  }
  return gravatarServerImport && isGravatarUrl(url) ? null : url;
}
